<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

        <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden">
            <userLeft :active="0" />
            <div class="box5 box-new">
                <div style="width: 50%; height: 100%;">
                    <img
                        v-if="user_data.avatar"
                        :src="'/api/file/preview/' + user_data.avatar"
                        class="user_img"
                        alt=""
                        style="
border: 2px solid rgba(43, 154, 52, 0.5);"
                    />
                    <img
                        v-else
                        src="../assets/useer-defaultimg@2x.png"
                        class="user_img"
                        alt=""
                        style="
border: 2px solid rgba(43, 154, 52, 0.5);"
                    />

                    <div style="float: left; margin-left: 4%;width: 70%;">
                        <div class="level_txt">
                            会员等级：
                            <span class="vip_txt" style="margin-left: 10px;">{{ user_data.vip ? user_data.vip.alias : '普通用户' }}</span>
                        </div>
                        <div style="overflow: hidden">
                            <div style="overflow: hidden">
                                <div class="user_name_left" style="width: 23.5%;margin-left: 4px;">昵称：</div>
                                <div class="user_name_left" style="text-align: left;width: 69%;margin-left: 17px;">
                                    {{ user_data.nickname }}
                                </div>
                            </div>
                            <div style="overflow: hidden">
                                <div class="user_name_left" style="width: 23.5%;margin-left: 4px;">科隆号：</div>
                                <div class="user_name_left" style="text-align: left;width: 69%;margin-left: 17px;">
                                    {{ user_data.keLongNumber }}
                                </div>
                            </div>
                            <div style="overflow: hidden">
                                <div class="user_name_left" style="width: 23.5%;margin-left: 4px;">绑定手机：</div>
                                <div class="user_name_left" style="text-align: left;width: 57%;margin-left: 16px;">
                                    {{ user_data.mobile ? user_data.mobile : '未绑定' }}
                                </div>
                            </div>
                        </div>
                        <router-link to="/user_info_edit"><div class="edit_link">修改个人信息>></div></router-link>
                    </div>
                </div>
                <div style="border: 1px solid #E8E6E6;width: 1px;"></div>
                <div style="width: 49%; height: 100%;" class="account-properties">
                    <div>
                        <div class="title">账号属性：</div>
                        <div class="green" v-if="account.accountAttr == 'parent'">主账号</div>
                        <div class="green" v-else-if="account.accountAttr == 'child'">子账号</div>
                        <div class="green" v-else>-</div>
                    </div>
                    <div>
                        <div class="title">{{ account.accountAttr == 'parent' ? '子账号：' : '主账号：' }}</div>
                        <div class="value">
                            <template v-if="account.info.length == 0">
                                <div>-</div>
                            </template>
                            <template v-else-if="account.accountAttr == 'child'">
                                <div>{{ account.info[0].companyFullName }}</div>
                                <div>
                                    {{ account.info[0].unifiedSocialCreditCode }}
                                </div>
                                <div>
                                    {{ `${account.info[0].name}（${account.info[0].phone}）` }}
                                </div>
                            </template>
                            <template v-else>
                                <div v-for="(item, i) in account.info" :key="i">
                                    {{ `${item.name}（${item.phone}）` }}
                                </div>
                            </template>
                        </div>
                    </div>
                    <div style="width: 100%; height: 60%; margin: 0 auto">
            <div style="overflow: hidden">
              <div style="width: 100%; float: left">
                <div class="user_right_txt">
                  完善信息再购物下单
                </div>
              </div>
              <div style="width: 100%; float: left">
                <router-link to="/user_info"
                  ><div class="user_right_txt" style="color: #2c9a34;">
                    完善个人信息
                  </div></router-link
                >
              </div><div style="width: 100%;float: left">
                <router-link to="/enterprise_info"
                  ><div class="user_right_txt" style="color: #2c9a34;">
                    完善企业信息
                  </div></router-link
                >
              </div>
            </div>
          </div>
                    <!-- <div style="width: 80%; height: 60%; margin: 4% auto">
            <div style="overflow: hidden">
              <div style="width: 50%; float: left">
                <div class="user_right_txt">
                  我的积分：{{ user_data.pointBalance }}
                </div>
              </div>
              <div style="width: 50%; float: left">
                <router-link to="/collection"
                  ><div class="user_right_txt">
                    我的收藏：{{ favorites.length }}
                  </div></router-link
                >
              </div>
            </div>
            <div style="overflow: hidden">
              
              <div style="width: 50%; float: left">
                <router-link to="/footprint"
                  ><div class="user_right_txt">
                    我的足迹：{{ footprint.length }}
                  </div></router-link
                >
              </div>
            </div>
          </div> -->
                </div>
            </div>
            <div class="box5 imgList">
                <div class="card bg1">
                    <div class="title">
                        我的积分：
                    </div>
                    <div class="value">
                        {{ user_data.pointBalance }}
                    </div>
                </div>
                <div class="card bg2">
                    <div class="title">
                        我的收藏：
                    </div>
                    <div class="value">
                        {{ favorites.length }}
                    </div>
                </div>
                <div class="card bg3">
                    <div class="title">
                        我的足迹：
                    </div>
                    <div class="value">
                        {{ footprint.length }}
                    </div>
                </div>
            </div>

            <div class="box5" style="padding: 0">
                <div class="table_head">
                    <div style="float: left; height: 100%">待付款订单 ( {{ order_list.length }} )</div>
                    <router-link to="order"
                        ><div style="float: right; height: 100%; color: #333">
                            查看全部订单
                        </div></router-link
                    >
                </div>

                <div v-if="order_list.length > 0">
                    <div class="item-header">
                        <span>订单详情</span>
                        <span>单价</span>
                        <span>运费</span>
                        <!-- <span>付款金额</span> -->
                        <!-- <span>收货人</span> -->
                        <span>状态</span>
                        <span>操作</span>
                    </div>

                    <div v-for="(item, index) in order_list" style="overflow: hidden;margin-top: 20px;">
                        <div class="order_box">
                            <div
                                style="
                width: 96%;
                margin: auto;
                border-bottom: 1px solid #ede9e9;
                overflow: hidden;
                padding: 8px 0;
              "
                            >
                                <div class="order_item_titles" style="width:200px">订单编号：{{ item.orderSn }}</div>
                                <div class="order_item_titles" style="width:250px">商家名称：{{ item.storeName }}</div>
                                <div class="order_item_titles" style="width:50px">{{ item.storeType == 'SELF' ? '自营' : '普通' }}</div>
                                <div class="order_item_titles">仓库名称：{{ item.warehouseName }}</div>
                                <div class="order_item_time">订单过期时间：{{ item.autoCloseTime }}</div>
                            </div>

                            <div style="width: 96%; margin: auto; overflow: hidden;border-bottom: 1px solid #ede9e9;">
                                <div style="width: 75%; float: left; overflow: hidden;">
                                    <div class="goods_left_item" v-for="(_item, index) in item.ordersItemList">
                                        <div @click="tiao(_item, index)" class="tiao">
                                            <img :src="`/api/file/preview/${_item.cover ? _item.cover : 'null'}`" alt="" style="width:50px;height:50px" />
                                        </div>
                                        <div @click="tiao(_item, index)" class="tiao" style="width:150px;display:flex;flex-direction:column;align-items:center;">
                                            <span style="line-height:15px;margin:40px 0 0px 0">{{ _item.productName }}</span>
                                            <span v-if="_item.skuSn" style="line-height:30px">({{ _item.skuSn }})</span>
                                        </div>
                                        <div>
                                            <span>{{ _item.specification }}</span>
                                        </div>
                                        <div>x {{ _item.quantity }}</div>
                                        <div>包装: {{ _item.packaging }}</div>
                                        <div style="margin-right: 60px; color: #f24145">￥{{ _item.price / 100 }}</div>
                                        <div style="margin-right: 40px; color: #f24145">￥{{ _item.freight / 100 || 0 }}</div>
                                    </div>
                                </div>
                                <div
                                    style="
                  float: left;
                  overflow: hidden;
                  width: 25%;
                  margin-top: 10px;
                "
                                >
                                    <div style="overflow: hidden; float: right;">
                                        <div class="order_item_title" style="margin-right: 40px" v-if="item.orderStatus == 'PENDING_PAYMENT'">
                                            待付款
                                        </div>
                                        <div class="order_item_title" style="margin-left: 40px">
                                            <div class="querenshouh" v-if="item.orderStatus == 'PENDING_PAYMENT'" @click="dindancaozuo(item)">
                                                立即支付
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="display:flex;justify-content:space-between;">
                                <div style="margin:8px 20px">
                                    <span style="margin-right:20px;font-size:13px;">收货人：{{ item.receiverBean.consignee }}</span>
                                    <span>{{ item.receiverBean.phone }}</span>
                                </div>
                                <div style="margin:8px 20px" v-if="item.paymentMethodName">
                                    <span>支付方式：{{ item.paymentMethodName }}</span>
                                </div>
                                <div style="margin:8px 20px;font-size:13px;">
                                    <span>付款金额：</span>
                                    <span style="color: #f24145;">￥{{ item.orderAmount / 100 }}</span>
                                    <span style="color: #666;">( 含运费 )</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="order_list.length == 0" style="text-align: center; font-size: 14px; margin-top: 40px;padding-bottom: 20px;">
                    没有未完成订单~
                </div>
            </div>
        </div>
        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
export default {
    name: 'integral',
    components: {
        userLeft,
        htmlHeader,
        foot
    },
    data() {
        return {
            yueShow: true, //显示余额
            user_data: '', //用户数据
            footprint: '', //足迹
            favorites: '', //收藏
            order_list: [], //待付款订单
            page: 0,
            account: null
        };
    },
    methods: {
        tiao(e) {
            this.$router.push('/goods_details?uuid=' + e.productId);
        },
        // 订单操作
        dindancaozuo(e) {
            if (e.orderStatus == 'PENDING_PAYMENT') {
                // 待付款 去付款也

                this.$router.push('/credit_pay?uuid=' + e.uuid);
            }
            if (e.orderStatus == 'SHIPPED') {
                // 待收货
            }
        },
        // 获取未付款订单
        get_my_orders() {
            this.api
                .get_my_orders({
                    size: 10,
                    page: this.page,
                    search: '',
                    status: 'PENDING_PAYMENT'
                })
                .then(res => {
                    if (res.ok) {
                        this.order_list = res.data.content;
                        console.log('商品数据');
                        console.log(this.order_list);
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        // 用户信息
        get_user_info() {
            this.api.user_info().then(res => {
                this.user_data = res.data;
            });
        },
        // 收藏
        get_favorites() {
            this.api.get_favorites().then(res => {
                this.favorites = res.data.content;
                console.log(this.favorites);
            });
        },
        // 足迹
        get_footprint() {
            this.api.get_footprint({ page: 0, size: 10 }).then(res => {
                this.footprint = res.data.content;
            });
        },
        getAccountList2() {
            this.api.getAccountList2().then(res => {
                console.log(res,'+++++++++++++++++++++++++++++');
                this.account = res.data;
                // debugger;
            });
        }
    },
    created() {
        this.get_user_info();
        this.get_favorites();
        this.get_footprint();
        this.get_my_orders();
        this.getAccountList2();
    }
};
</script>

<style scoped>
.box-new {
    display: flex;
}
.item-header {
    display: flex;
    margin-top: 20px;
    padding-left: 20px;
    line-height: 40px;
    color: rgb(255, 255, 255);
    background: #2b9a34;
}
.tiao:hover {
    cursor: pointer;
}
.item-header span:first-child {
    width: 520px;
}
.item-header span:nth-child(2) {
    width: 110px;
}
.item-header span:nth-child(3) {
    width: 190px;
}
.item-header span:nth-child(4) {
    width: 90px;
}
.item-header span:nth-child(5) {
    width: 90px;
}
.table_head {
    width: 100%;
    height: 40px;
    background: #f4f4f4;
    padding: 0 2%;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 40px;
    overflow: hidden;
}

.user_right_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
}
.edit_link {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2c9a34;
    margin-top: 2%;
}

.user_name_left {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    width: 50%;
    text-align: right;
    float: left;
    margin-top: 5px;
}

.vip_txt {
    font-family: MicrosoftYaHei-Bold;
    font-weight: Bold;
    color: #2c9a34;
    font-size: 18px;
}

.level_txt {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    text-align: left;
}

.user_img {
    width: 80px;
    height: 80px;
    float: left;
    margin-top: 2%;
    margin-left: 2%;
    border-radius: 50%;
}

.box5 {
    width: 80%;
    border: 1px solid #ede9e9;
    float: right;
    margin-top: 2%;
    padding: 2%;
}
.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}
.order_item_time {
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    line-height: 16px;
    float: right;
}
.order_item_titles {
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    float: left;
}

.order_item_title {
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    float: left;
}

.order_box {
    width: 100%;
    border: 1px solid #ede9e9;
}
.goods_left_item {
    height: 100px;
    line-height: 100px;
    border-right: 1px solid #ede9e9;
    display: flex;
    justify-content: space-between;
}
.head_items2 {
    width: 100%;
    padding: 0 2%;
    height: 40px;
    background: #f4f4f4;
    margin-top: 4%;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: center;
}

.querenshouh {
    width: 60px;
    height: 24px;
    border: 1px solid #2b9a34;
    cursor: pointer;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    text-align: center;
    line-height: 24px;
}
.account-properties {
    padding: 0 30px 0 40px;
}
.account-properties > div {
    display: flex;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
}
.account-properties .green {
    color: #2b9a34;

    font-weight: 600;
}
.account-properties .title {
    width: 80px;
    flex-shrink: 0;
    text-align: right;
}
.imgList {
    border: 0;
    display: flex;
    justify-content: space-between;
    padding: 0;
}
.imgList > div {
    width: 305px;
    height: 90px;
    display: flex;
    align-items: center;
    background-size: 100%;
    padding-left: 20px;
}
.bg1 {
    background-image: url('../assets/card-blue@2x.png');
}
.bg2 {
    background-image: url('../assets/card-orange@2x.png');
}
.bg3 {
    background-image: url('../assets/card-green@2x.png');
}
.card .value {
    font-size: 34px;
    font-family: DIN-Medium, DIN;
    font-weight: 600;
    line-height: 44px;
}
.card .title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 20px;
}
.bg1 .value {
    color: rgba(92, 160, 249, 0.6);
}
.bg1 .title {
    color: #5ca0f9;
}
.bg2 .value {
    color: rgba(255, 111, 42, 0.5);
}
.bg2 .title {
    color: #ff6f2a;
}
.bg3 .value {
    color: rgba(83, 196, 158, 0.5);
}
.bg3 .title {
    color: #53c49e;
}
</style>



// WEBPACK FOOTER //
// src/components/user.vue